export default __webpack_public_path__ + "static/media/background-create-new-scholarship.9f12f1a6.png";